interface ThinkingIndicatorProps {
  message?: string;
}

export const ThinkingIndicator = ({
  message = 'Stella is thinking',
}: ThinkingIndicatorProps) => {
  return (
    <div className="markdown-content" aria-live="polite">
      <p className="mb-4 text-muted-foreground leading-relaxed last:mb-0 animate-pulse">
        {message}
        <span
          className="inline-flex gap-1 items-center ml-1"
          aria-hidden="true"
        >
          <span className="w-1 h-1 rounded-full bg-current" />
          <span className="w-1 h-1 rounded-full bg-current animate-pulse [animation-delay:0.2s]" />
          <span className="w-1 h-1 rounded-full bg-current animate-pulse [animation-delay:0.4s]" />
        </span>
      </p>
    </div>
  );
};
